<div class="container pb-10">

  <div class="flex justify-between mx-8 mb-6 mt-13">
    <h1 class="text-blue-600 text-heading-lg font-bold m-0">
      Diagnóstico e projeção da oferta educacional
    </h1>

    <img src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer" (click)="baixarCsvDimensaoOferta()">
  </div>


  <div class="table-content rounded-sm sm-shadow mx-8">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr class="header-row">
          <th class="top-left-header text-body-lg align-start" style="width: 25%">Dimensão da oferta<sup>(1)</sup></th>
          <th class="top-header text-body-lg align-start" style="width: 25%">Atual - {{anosReferencias?.anoCenso ?? 2025}}</th>
          <th class="top-header text-body-lg align-start" style="width: 25%">Projeção - {{anosReferencias?.anoPqr ?? 2026}}</th>
          <th class="top-right-header text-body-lg align-start" style="width: 25%">
            Variação {{anosReferencias?.anoCenso ?? 2025}}-{{anosReferencias?.anoPqr ?? 2026}}<sup>(3)</sup>
          </th>
        </tr>
      </ng-container>
      <ng-container corpo>

        <tr *ngIf="carregandoDados" class="cells-row">
          <td colspan="4" class="table-loader">
            <div class="loader-container">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
          </td>
        </tr>

        <tr *ngIf="!carregandoDados && !variacaoDimensaoOferta" class="cells-row">
          <td colspan="4" class="text-center py-8 text-gray-500">
            Não foi possível carregar os dados. Verifique se você selecionou uma localização válida.
          </td>
        </tr>

        <ng-container *ngIf="!carregandoDados && variacaoDimensaoOferta && memoriaDeCalculo">
          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-800-important align-start">
              Número de matrículas
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                variacaoDimensaoOferta.numeroMatriculas | number: '1.0-0'
              }}
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                numerosDeMatriculas?.total | number: '1.0-0'
              }}
            </td>
            <td class="right-cell text-body-lg text-charcoal-800-important align-start">
              {{
                porcentagemDoValorNumeroReal(
                  calcularVariacao(
                    numerosDeMatriculas?.total ?? 0,
                    variacaoDimensaoOferta.numeroMatriculas
                  ),
                  variacaoDimensaoOferta.numeroMatriculas
                ) | percent : '1.1-1'
              }}
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-800-important align-start">
              Número de turmas
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                variacaoDimensaoOferta.numeroTurmas | number: '1.0-0'
              }}
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                (
                  featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') && featureFlagService.funcionalidadeHabilitada('1104-creche-idade') && memoriaDeCalculo.resultadoCalcNumTurmas
                    ? memoriaDeCalculo.resultadoCalcNumTurmas.total
                    : memoriaDeCalculo.resultadoEtapa4CalculoNumeroTurmas?.total
                ) ?? 0 | number: '1.0-0'
              }}
            </td>
            <td class="right-cell text-body-lg text-charcoal-800-important align-start">
              {{
                porcentagemDoValorNumeroReal(
                  calcularVariacao(
                    (
                      featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') && featureFlagService.funcionalidadeHabilitada('1104-creche-idade') && memoriaDeCalculo.resultadoCalcNumTurmas
                        ? memoriaDeCalculo.resultadoCalcNumTurmas.total
                        : memoriaDeCalculo.resultadoEtapa4CalculoNumeroTurmas?.total
                    ) ?? 0,
                    variacaoDimensaoOferta.numeroTurmas
                  ),
                  variacaoDimensaoOferta.numeroTurmas
                ) | percent : '1.1-1'
              }}
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-800-important align-start">
              Número de professores<sup>(2)</sup>
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                variacaoDimensaoOferta.numeroDocentes | number: '1.0-0'
              }}
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                ((featureFlagService.funcionalidadeHabilitada('1104-creche-idade')
                    ? memoriaDeCalculo.resultadoCalcNumProf?.total
                    : memoriaDeCalculo.resultadoEtapa10CalculoDemandaPorDocentes?.total) ?? 0) | number: '1.0-0'
              }}
            </td>
            <td class="right-cell text-body-lg text-charcoal-800-important align-start">
              {{
                porcentagemDoValorNumeroReal(
                  calcularVariacao(
                    (featureFlagService.funcionalidadeHabilitada('1104-creche-idade')
                      ? memoriaDeCalculo.resultadoCalcNumProf?.total
                      : memoriaDeCalculo.resultadoEtapa10CalculoDemandaPorDocentes?.total) ?? 0,
                    variacaoDimensaoOferta.numeroDocentes
                  ),
                  variacaoDimensaoOferta.numeroDocentes
                ) | percent : '1.1-1'
              }}
            </td>
          </tr>
          <tr class="cells-row">
            <td class="left-cell text-body-lg text-charcoal-800-important align-start">
              Número de auxiliares
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">
              {{
                variacaoDimensaoOferta.numeroAuxiliares | number: '1.0-0'
              }}
            </td>
            <td class="text-body-lg text-charcoal-800-important align-start">-</td>
            <td class="right-cell text-body-lg text-charcoal-800-important align-start">-</td>
          </tr>
          <tr class="cells-row">
            <td class="bottom-left-cell text-body-lg text-charcoal-800-important align-start">
              Número de funcionários
            </td>
            <td class="bottom-cell text-body-lg text-charcoal-800-important align-start">
              {{
                variacaoDimensaoOferta.numeroFuncionarios | number: '1.0-0'
              }}
            </td>
            <td class="bottom-cell text-body-lg text-charcoal-800-important align-start">
              {{
                memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total | number: '1.0-0'
              }}
            </td>
            <td class="bottom-right-cell text-body-lg text-charcoal-800-important align-start">
              {{
                porcentagemDoValorNumeroReal(
                  calcularVariacao(
                    memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total,
                    variacaoDimensaoOferta.numeroFuncionarios
                  ),
                  variacaoDimensaoOferta.numeroFuncionarios
                ) | percent : '1.1-1'
              }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </app-tabela>

    <div class="notas mt-2">
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">Notas:</p>
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">
        <sup>(1)</sup>
        A simulação considera as etapas da educação básica e a modalidade de educação de jovens e adultos (EJA) prioritárias para a
        rede pública estadual e/ou municipal. Na rede estadual, são contabilizadas as matrículas de ensino fundamental - anos iniciais,
        ensino fundamental - anos finais, ensino médio e EJA de ensino fundamental e médio. Na rede municipal, são incluídas as matrículas
        de creche, pré-escola, ensino fundamental - anos iniciais, ensino fundamental - anos finais e EJA de ensino fundamental.
      </p>
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">
        <sup>(2)</sup>
        O resultado da projeção do número de professores necessários depende do padrão de jornada de trabalho semanal adotado.
        Inicialmente, o simulador faz projeções considerando uma jornada de 40 horas semanais. Se necessário, edite o resultado
        e altere esse parâmetro de modo a expressar a jornada dos docentes da rede em análise.
      </p>
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">
        <sup>(3)</sup>
        Variação de valores entre o diagnóstico e o projetado.
      </p>
    </div>
  </div>

  <div class="flex justify-between mb-6 mt-18 mx-8">
    <h1 class="text-blue-600 text-heading-lg font-bold m-0">
      Projeção do número de funcionários
    </h1>

    <img src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer" (click)="baixarCsvFuncionarios()">
  </div>

  <div class="table-content rounded-sm sm-shadow mx-8">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr class="header-row">
          <th class="top-left-header text-body-lg align-start" style="width: 33%">
            Área de atuação
          </th>
          <th class="top-header text-body-lg align-start" style="width: 33%">
            Número de funcionários - {{anosReferencias?.anoCenso ?? 2025}}<sup>(1)</sup>
          </th>
          <th class="top-right-header text-body-lg align-start" style="width: 33%">
            Projeção do número necessário de funcionários - {{anosReferencias?.anoPqr ?? 2026}}
          </th>
        </tr>
      </ng-container>
      <ng-container corpo>

        <tr *ngIf="carregandoDados" class="cells-row">
          <td colspan="3" class="table-loader">
            <div class="loader-container">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
          </td>
        </tr>

        <tr *ngIf="!carregandoDados && !memoriaDeCalculo" class="cells-row">
          <td colspan="3" class="text-center py-8 text-gray-500">
            Não foi possível carregar os dados. Verifique se você selecionou uma localização válida.
          </td>
        </tr>

        <ng-container *ngIf="!carregandoDados && variacaoDimensaoOferta && memoriaDeCalculo">

        <tr class="cells-row" *ngFor="let funcao of funcionariosOrdenados; let i = index">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">{{ funcao.nomeFuncao }}</td>
          <td class="text-body-lg text-charcoal-800-important align-start"></td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">{{funcao.quantidade | number: '1.0-0'}}</td>
        </tr>
        <tr class="cells-row">
          <td class="bottom-left-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">Total</td>
          <td class="bottom-cell text-charcoal-800-important align-start bg-gray-100">
            {{
              variacaoDimensaoOferta.numeroFuncionarios | number: '1.0-0'
            }}
          </td>
          <td class="bottom-right-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
            {{
              memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total | number: '1.0-0'
            }}
          </td>
        </tr>
        </ng-container>
      </ng-container>
    </app-tabela>
    <div class="notas mt-2">
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">Notas:</p>
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">
        <sup>(1)</sup>
        O número de funcionários é obtido pela soma das variáveis que trazem a quantidade de funcionários por função
        (Administrativo; Bibliotecário; Serviços Gerais; Coordenador; Alimentação; Pedagogia; Secretário; Segurança; Monitores; Gestão)
      </p>
    </div>
  </div>

  <div class="flex justify-between mb-6 mt-18 mx-8">
    <h1 class="text-blue-600 text-heading-lg font-bold m-0">
      Projeção da complementação VAAT-CAQ
    </h1>

    <img src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer" (click)="baixarCsvDespesaComplementacao()">
  </div>

  <div class="table-content rounded-sm sm-shadow mx-8">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr class="header-row">
          <th class="top-left-header text-body-lg align-start" rowspan="2" style="width: 20%">
            Esfera Administrativa
          </th>
          <th class="top-header text-body-lg coluna-valor" rowspan="2" [style.width.%]="larguraColunaValorComplementacao">
            Receita Potencial mínima Vinculada à Educação (RPEB) (R$)<sup>(1)</sup> - {{anosReferencias?.anoPqr ?? 2026}}
          </th>
          <th class="top-header text-body-lg coluna-valor" colspan="2">
            {{ mostrarRpebAposVaat ? 'Complementação VAAT-CAQ' : 'Complementação' }} - {{anosReferencias?.anoPqr ?? 2026}}
          </th>
          <th class="top-header text-body-lg coluna-valor" rowspan="2" [style.width.%]="larguraColunaValorComplementacao" *ngIf="mostrarRpebAposVaat">
            RPEB após VAAT-CAQ - {{anosReferencias?.anoPqr ?? 2026}}
          </th>
        </tr>
        <tr class="header-row">
          <th class="text-body-lg coluna-valor" [style.width.%]="larguraColunaValorComplementacao">R$<sup>(2)</sup></th>
          <th class="text-body-lg coluna-valor" [style.width.%]="larguraColunaValorComplementacao">%<sup>(3)</sup></th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <tr *ngIf="carregandoDados" class="cells-row">
          <td [attr.colspan]="colunasTabelaComplementacao" class="table-loader">
            <div class="loader-container">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
          </td>
        </tr>

        <tr *ngIf="!carregandoDados && !diferencaOrcamento" class="cells-row">
          <td [attr.colspan]="colunasTabelaComplementacao" class="text-center py-8 text-gray-500">
            Não foi possível carregar os dados. Verifique se você selecionou uma localização válida.
          </td>
        </tr>

        <ng-container *ngIf="!carregandoDados && diferencaOrcamento && memoriaDeCalculo">

        <ng-template #tracoEstadual>-</ng-template>
        <ng-template #tracoMunicipal>-</ng-template>
        <ng-template #tracoTotal>-</ng-template>

        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Governo Estadual</td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            <ng-container *ngIf="!isEstadualVazio(diferencaOrcamento.receitaPotencialEstadual); else tracoEstadual">
              {{ (diferencaOrcamento.receitaPotencialEstadual) | number: '1.0-0' }}
            </ng-container>
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            <ng-container *ngIf="!isEstadualVazio(complementacaoEstadual); else tracoEstadual">
              {{ complementacaoEstadual | number: '1.0-0' }}
            </ng-container>
          </td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            <ng-container *ngIf="!isEstadualVazio(complementacaoEstadual); else tracoEstadual">
              {{ percentualComplementacao(complementacaoEstadual, diferencaOrcamento.receitaPotencialEstadual) | number: '1.1-1' }}
            </ng-container>
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start" *ngIf="mostrarRpebAposVaat">
            <ng-container *ngIf="!isEstadualVazio(diferencaOrcamento.receitaPotencialEstadual); else tracoEstadual">
              {{
                ((diferencaOrcamento.receitaPotencialEstadual === null? 0:diferencaOrcamento.receitaPotencialEstadual) +
                (complementacaoEstadual === null? 0 : complementacaoEstadual)) | number: '1.0-0'
              }}
            </ng-container>
          </td>
        </tr>


        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Governo Municipal</td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            <ng-container *ngIf="!isMunicipalVazio(diferencaOrcamento.receitaPotencialMunicipal); else tracoMunicipal">
              {{ diferencaOrcamento.receitaPotencialMunicipal | number: '1.0-0' }}
            </ng-container>
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            <ng-container *ngIf="!isMunicipalVazio(complementacaoMunicipal); else tracoMunicipal">
              {{ complementacaoMunicipal | number: '1.0-0' }}
            </ng-container>
          </td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            <ng-container *ngIf="!isMunicipalVazio(complementacaoMunicipal); else tracoMunicipal">
              {{ percentualComplementacao(complementacaoMunicipal, diferencaOrcamento.receitaPotencialMunicipal) | number: '1.1-1' }}
            </ng-container>
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start" *ngIf="mostrarRpebAposVaat">
            <ng-container *ngIf="!isMunicipalVazio(diferencaOrcamento.receitaPotencialMunicipal); else tracoMunicipal">
              {{
                ((diferencaOrcamento?.receitaPotencialMunicipal === null? 0:diferencaOrcamento.receitaPotencialMunicipal) +
                (complementacaoMunicipal === null? 0 : complementacaoMunicipal)) | number: '1.0-0'
              }}
            </ng-container>
          </td>
        </tr>
        <tr class="cells-row">
          <td class="bottom-left-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">Total</td>
          <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
            <ng-container *ngIf="!isEstadualVazio(diferencaOrcamento.receitaPotencialEstadual) && !isMunicipalVazio(diferencaOrcamento.receitaPotencialMunicipal); else tracoTotal">
              {{ (totalReceitaPotencialMinimaVinculada ) | number: '1.0-0' }}
            </ng-container>
          </td>
          <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
            <ng-container *ngIf="!isEstadualVazio(complementacaoEstadual) && !isMunicipalVazio(complementacaoMunicipal); else tracoTotal">
              {{ totalComplementacao | number: '1.0-0' }}
            </ng-container>
          </td>
          <td class="bottom-right-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">
            <ng-container *ngIf="!isEstadualVazio(complementacaoEstadual) && !isMunicipalVazio(complementacaoMunicipal); else tracoTotal">
              {{ percentualComplementacao(totalComplementacao, totalReceitaPotencialMinimaVinculada) | number: '1.1-1' }}
            </ng-container>
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start" *ngIf="mostrarRpebAposVaat">
            <ng-container *ngIf="!isEstadualVazio(diferencaOrcamento.receitaPotencialEstadual) && !isMunicipalVazio(diferencaOrcamento.receitaPotencialMunicipal); else tracoTotal">
              {{
                (totalComplementacao +  totalReceitaPotencialMinimaVinculada ) | number: '1.0-0'
              }}
            </ng-container>
          </td>
        </tr>
        </ng-container>
      </ng-container>
    </app-tabela>
    <div class="notas mt-2">
      <p class="text-body-xs text-charcoal-800 m-0">Notas:</p>
      <p class="text-body-xs text-charcoal-800 m-0">
      <sup>(1)</sup>
         Receita Potencial mínima Vinculada à Educação (RPEB) = [RLI x 25% - receitas destinadas ao Fundeb
         + receitas recebidas do Fundeb + complementações da União ao Fundeb + Salário Educação (cota estadual/municipal)
        + Receitas de Programas do FNDE (PNAE + PNATE + PDDE + PNLD) + Royalties de Petróleo e Gás]. A RLI é a “receita resultante
        de impostos, compreendida a proveniente de transferências”, base de cálculo da vinculação constitucional de recursos
        para a educação (Art. 212 da CF).
      </p>

      <p class="text-body-xs text-charcoal-800 m-0">
        A RPEB é calculada com base nos dados das Receitas projetadas para 2026 utilizadas para o cálculo do VAAT fornecidas pelo FNDE
        e dados da Complementação VAAT do Fundeb disponíveis no portal de Transferências Constitucionais da Secretaria do Tesouro Nacional (STN).
      </p>

      <p class="text-body-xs text-charcoal-800 m-0">
        As receitas nominais de 2024 foram projetadas para 2026 utilizando o percentual de 23,22%. A projeção das receitas foi estabelecida no Parágrafo único,
        Art. 15 da Lei 14.113/2020, e o percentual para 2026 foi calculado pelo Ministério da Fazenda e divulgado na Nota Técnica SEI nº 4176/2025/MF.
      </p>

      <p class="text-body-xs text-charcoal-800 m-0">
        Acesse os valores da Receita Potencial mínima Vinculada à Educação (RPEB) 2026 por ente federativo
        <a href="https://docs.google.com/spreadsheets/d/1jURjIn3TWatCfvGbRNu-iBSv9C09g-m_/edit?usp=sharing&ouid=114327122607200076186&rtpof=true&sd=true"
          target="_blank" rel="noopener noreferrer">AQUI</a>.
      </p>

      <p class="text-body-xs text-charcoal-800 m-0">
        <sup>(2)</sup>
        O montante da Complementação VAAT-CAQ apresentada nesta tabela foi calculado pelo somatório da diferença entre o ‘Orçamento CAQ’
        e a ‘RPEB’ em cada ente federativo (quando o Orçamento CAQ foi maior que a RPEB).
      </p>

      <p class="text-body-xs text-charcoal-800 m-0">
        <sup>(3)</sup>
        % Complementação VAAT-CAQ = (Complementação VAAT-CAQ / Receita Potencial mínima Vinculada à Educação) * 100.
      </p>

      <p class="text-body-xs text-charcoal-800 mt-2 mb-0">
        <strong>Fontes:</strong>
      </p>

      <ul class="text-body-xs text-charcoal-800 m-0">
        <li>
          <a href="https://www.gov.br/fnde/pt-br/acesso-a-informacao/acoes-e-programas/financiamento/fundeb/2026-1/MemriadeClculoVAAT2026.xlsx"
            target="_blank" rel="noopener noreferrer">
            Planilha com os dados divulgados pelo FNDE sobre as receitas utilizadas para o cálculo do VAAT 2026 referentes às realizadas no penúltimo exercício financeiro anterior ao de referência (2024)
          </a>
        </li>
        <li>
          <a href="https://www.tesourotransparente.gov.br/consultas/transferencias-constitucionais-realizadas"
            target="_blank" rel="noopener noreferrer">
            Transferências Constitucionais e Legais / Secretaria do Tesouro Nacional
          </a>
        </li>
        <li>
          <a href="https://siconfi.tesouro.gov.br/siconfi/index.jsf"
            target="_blank" rel="noopener noreferrer">
            Relatório Resumido da Execução Orçamentária (RREO) publicado pela Secretaria do Tesouro Nacional (STN/Siconfi/Finbra) utilizado para o cálculo da RPEB dos entes com dados ausentes na planilha do FNDE
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Detalhamento da despesa necessária (#1106) — após a seção Projeção da complementação VAAT-CAQ -->
  <div class="mx-8" *ngIf="mostrarDetalhamentoDespesa">
    <app-tabela-detalhamento-despesa
      [estiloProjecao]="true"
      [memoria]="memoriaDeCalculo!"
      (downloadClick)="baixarCsvDetalhamentoDespesa()">
    </app-tabela-detalhamento-despesa>
  </div>

  <!-- Adicional para modalidades e contextos (#1105) — após a seção Projeção da complementação VAAT-CAQ -->
  <div class="mx-8" *ngIf="mostrarAdicionalModalidade">
    <app-tabela-adicional-modalidade
      [estiloProjecao]="true"
      [matriculas]="memoriaDeCalculo!.resultadoMatriculasFatorPonderacao!"
      [despesa]="memoriaDeCalculo!.resultadoDistribuicaoDespesaPorEtapa!"
      (downloadClick)="baixarCsvAdicionalModalidade()">
    </app-tabela-adicional-modalidade>
  </div>

  <!-- TABELA 5 – Projeção da despesa de capital (construção de novos prédios) -->
  <div class="flex justify-between mb-6 mt-18 mx-8"
    *ngIf="featureFlagService.funcionalidadeHabilitada('novas-salas')">
    <h1 class="text-blue-600 text-heading-lg font-bold m-0">
      Projeção da despesa de capital (construção de novos prédios)
    </h1>
  </div>

  <div class="table-content rounded-sm sm-shadow mx-8"
    *ngIf="featureFlagService.funcionalidadeHabilitada('novas-salas')">
    <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
      <ng-container cabecalho>
        <tr class="header-row">
          <th class="top-left-header text-body-lg align-start" rowspan="2" style="width: 20%">
            Esfera Administrativa
          </th>
          <th class="top-header text-body-lg align-start" rowspan="2" style="width: 20%">
            Investimento Total (R$)
          </th>
          <th class="top-header text-body-lg align-start" colspan="2" style="width: 30%">
            Educação Infantil
          </th>
          <th class="top-right-header text-body-lg align-start" colspan="2" style="width: 30%">
            Ens. Fund. / Médio / EJA
          </th>
        </tr>
        <tr class="header-row">
          <th class="text-body-lg align-start">R$</th>
          <th class="text-body-lg align-start">%</th>
          <th class="text-body-lg align-start">R$</th>
          <th class="text-body-lg align-start">%</th>
        </tr>
      </ng-container>
      <ng-container corpo *ngIf="memoriaDeCalculo">
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start bold">{{ planoSelecionado?.label || 'Total' }}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            {{ formatarDinheiro(memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosTotal ?? 0) }}
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            {{
              formatarDinheiro(
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual ?? 0) +
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal ?? 0)
              )
            }}
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            {{
              formatarPorcentagemDoValorOuTraco(
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual ?? 0) +
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal ?? 0),
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosTotal ?? 1)
              )
            }}
          </td>
          <td class="text-body-lg text-charcoal-800-important align-start">
            {{
              formatarDinheiro(
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual ?? 0) +
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal ?? 0)
              )
            }}
          </td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              formatarPorcentagemDoValorOuTraco(
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual ?? 0) +
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal ?? 0),
                (memoriaDeCalculo?.relatorioCaq?.projecaoDespesaConstrucaoNovosPrediosTotal ?? 1)
              )
            }}
          </td>
        </tr>
      </ng-container>
    </app-tabela>
  </div>

  <div class="flex justify-between mb-6 mt-18 mx-8">
    <h1 class="text-blue-600 text-heading-lg font-bold m-0">
      Projeção das matrículas e da despesa por etapa/modalidade
    </h1>

    <img src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer" (click)="baixarCsvMatriculasDespesas()">
  </div>

  <div class="table-content rounded-sm sm-shadow mx-8">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr class="header-row">
          <th class="top-left-header text-body-lg align-start">Etapa / Modalidade</th>
          <th class="top-header text-body-lg align-start">Projeção das matrículas - {{anosReferencias?.anoPqr ?? 2026}}</th>
          <th class="top-header text-body-lg align-start">Projeção da despesa necessária (R$) - {{anosReferencias?.anoPqr ?? 2026}}</th>
          <th class="top-right-header text-body-lg align-start">%<sup>(7)</sup></th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <tr *ngIf="carregandoDados" class="cells-row">
          <td colspan="4" class="table-loader">
            <div class="loader-container">
              <mat-spinner diameter="48"></mat-spinner>
            </div>
          </td>
        </tr>

        <tr *ngIf="!carregandoDados && !memoriaDeCalculo" class="cells-row">
          <td colspan="4" class="text-center py-8 text-gray-500">
            Não foi possível carregar os dados. Verifique se você selecionou uma localização válida.
          </td>
        </tr>

        <ng-container *ngIf="!carregandoDados && memoriaDeCalculo">
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Creche</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ numerosDeMatriculas?.creche | number: '1.0-0'}}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ calcularProjecaoDespesaCreche() | number: '1.0-0'}}</td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaCreche(),
                obterDespesaCorrenteAno()
              ) * 100 | number : '1.1-1'
            }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Pré-Escola</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ numerosDeMatriculas?.preEscola | number: '1.0-0'}}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ calcularProjecaoDespesaPreEscola() | number: '1.0-0'}}</td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaPreEscola(),
                obterDespesaCorrenteAno()
              ) * 100 | number : '1.1-1'
            }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Ensino Fundamental - anos iniciais</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ numerosDeMatriculas?.ensFunAnosIniciais | number: '1.0-0'}}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ calcularProjecaoDespesaEFAnosIniciais() | number: '1.0-0'}}</td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEFAnosIniciais(),
                obterDespesaCorrenteAno()
              ) * 100 | number : '1.1-1'
            }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Ensino Fundamental - anos finais</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ numerosDeMatriculas?.ensFunAnosFinais | number: '1.0-0' }}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ calcularProjecaoDespesaEFAnosFinais() | number: '1.0-0' }}</td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEFAnosFinais(),
                obterDespesaCorrenteAno()
              ) * 100 | number : '1.1-1'
            }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">Ensino Médio</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ numerosDeMatriculas?.ensMedio | number: '1.0-0' }}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ calcularProjecaoDespesaEM() | number:'1.0-0' }}</td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEM(),
                obterDespesaCorrenteAno()
              ) * 100 | number : '1.1-1'
            }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="left-cell text-body-lg text-charcoal-800-important align-start">EJA</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ numerosDeMatriculas?.eja | number:'1.0-0' }}</td>
          <td class="text-body-lg text-charcoal-800-important align-start">{{ calcularProjecaoDespesaEJA() | number: '1.0-0'}}</td>
          <td class="right-cell text-body-lg text-charcoal-800-important align-start">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEJA(),
                obterDespesaCorrenteAno()
              ) * 100 | number : '1.1-1'
            }}
          </td>
        </tr>
        <tr class="cells-row">
          <td class="bottom-left-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">Total</td>
          <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">{{ numerosDeMatriculas?.total | number: '1.0-0'}}</td>
          <td class="bottom-cell text-body-lg text-charcoal-800-important align-start bg-gray-100">{{ obterDespesaCorrenteAno() | number:'1.0-0'}}</td>
          <td class="bottom-right-cell text-body-lg text-charcoal-800-important align-start bg-gray-100"></td>
        </tr>
        </ng-container>
      </ng-container>
    </app-tabela>
    <div class="notas mt-2">
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">Notas:</p>
      <p class="text-body-xs text-charcoal-800 m-0 text-body-xs">
        <sup>(8)</sup>
        Porcentagem do orçamento por etapa.
      </p>
    </div>
  </div>

  <!-- Salas de aula: diagnóstico e projeção (#1472) — última tabela do relatório -->
  <div class="mx-8" *ngIf="mostrarTabelaSalasDeAula">
    <app-tabela-salas-de-aula
      [estiloProjecao]="true"
      [salasExistentes]="memoriaDeCalculo!.resultadoParte9_2ResultadoSalasExistentes"
      [salasNecessarias]="memoriaDeCalculo!.resultadoParte9_3ResultadoSalasNecessarias"
      [demandaNovasSalas]="memoriaDeCalculo!.resultadoParte9_4DemandaPorNovasSalas"
      [carregandoPdf]="carregandoPdfSalasDeAula"
      (pdfClick)="baixarPdfSalasDeAula()">
    </app-tabela-salas-de-aula>
  </div>
  <div class="table-content rounded-sm sm-shadow mx-8 notas mt-2">

    <p class="text-body-xs text-charcoal-800 m-0">
      Nota:<br/>
      A proposta de valores do PQR apresentada nesse documento foi realizada pela
      equipe do projeto. Desse modo, não foram decisões do governo federal, dos
      governos estaduais ou municipais. Por consequência, os resultados do SimCAQ
      decorrentes dos parâmetros de qualidade propostos não vinculam a
      responsabilidade de repasses de recursos financeiros por parte dos entes
      federativos.
    </p>
  </div>
</div>
